import { FontAwesomeIconStyle } from '../icon/font-awesome-icon-style.enum';
import { FontAwesomeIcon } from '../icon/font-awesome-icon.interface';

export const FONT_AWESOME_ICONS: FontAwesomeIcon[] = [
  {
    name: 'fas fa-file',
    style: FontAwesomeIconStyle.Regular
  },
  {
    name: 'fas fa-share-square',
    style: FontAwesomeIconStyle.Regular
  },
  {
    name: 'fas fa-user',
    style: FontAwesomeIconStyle.Regular
  },
  {
    name: 'fas fa-save',
    style: FontAwesomeIconStyle.Regular
  },
  {
    name: 'fas fa-archive',
    style: FontAwesomeIconStyle.Regular
  },
  {
    name: 'fas fa-arrows-alt',
    style: FontAwesomeIconStyle.Regular
  },
  {
    name: 'fas fa-adjust',
    style: FontAwesomeIconStyle.Regular
  },
  {
    name: 'fas fa-clone',
    style: FontAwesomeIconStyle.Regular
  }
];
